import { Component } from '@angular/core';

@Component({
  selector: 'empathy-terminate-description',
  templateUrl: 'terminate-description.component.html',
  styleUrls: ['./terminate-description.component.scss']
})
export class TerminateDescriptionComponent {}
